import * as BluebirdPromise from "bluebird";
import AxiosServiceHandler from "./AxiosServiceHandler";
import {ProductImageStacType} from "../types/product";

class ProductImageService extends AxiosServiceHandler {
  private static pendingRequestsCount: number = 0;

  static getQuicklookPreview(productImage: ProductImageStacType) {
    const _this = this;
    const CancellablePromise = BluebirdPromise.config({
      cancellation: true
    })
    return new CancellablePromise((resolve, reject, onCancel) => {
      let interval = setInterval(() => {
        if (_this.getPendingRequestsCount() <= 5) {
          _this.addAPendingRequest();
          clearInterval(interval);
          resolve(
            _this.getInstance()
              .get(`${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_QUICKLOOK}/${productImage.id}?type=quicklook`, {
                headers: {
                  "Content-Type": "image/jpeg",
                },
                responseType: "blob"
              }).then((response) => {
                _this.removeAPendingRequest();
                return response
              }).catch((errors) => {
                _this.removeAPendingRequest();
                return errors
              })
          )
        }
      }, 200);

      onCancel(() => {
        clearInterval(interval);
        reject(new Error('Cancel'));
      });
    });
  }

  static getPendingRequestsCount() {
    return this.pendingRequestsCount;
  }

  static addAPendingRequest() {
    this.pendingRequestsCount = this.getPendingRequestsCount() + 1;
  }

  static removeAPendingRequest() {
    this.pendingRequestsCount = Math.max(0, this.getPendingRequestsCount() - 1);
  }
}

export default ProductImageService;
